export default __webpack_public_path__ + "static/media/getsafe.054a5463.svg";